import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import colors from "styles/colors";
import componentStyles from "./collaboration-with-component.scss";
import { fixDevImageUrl } from "/services/community/url-service";
class CollaborationWithComponent extends PureComponent {
    render() {
        const { imageUrl, color, text } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            style: {
                color: colors[color]
            },
            className: `jsx-${componentStyles.__hash}` + " " + "collaboration-with-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "collaboration-with-text",
                    children: text
                }),
                imageUrl && /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "collaboration-with-image-wrapper",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: fixDevImageUrl(imageUrl),
                        className: `jsx-${componentStyles.__hash}` + " " + "collaboration-with-image"
                    })
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
}
export { CollaborationWithComponent as default };
CollaborationWithComponent.defaultProps = {
    color: "black",
    text: "Powered By"
};
